import { Moment } from 'moment'
import React, { useContext } from 'react'

import { ItemCardVariant } from './ItemCard'
import ViewNearbyExperiencesCta from '../Buttons/ViewNearbyExperiencesCta'
import ViewNearbyToursCta from '../Buttons/ViewNearbyToursCta'

import TextButton from 'components/Luxkit/Button/TextButton'
import Group from 'components/utils/Group'
import SaveTripItemButton from 'tripPlanner/components/Buttons/SaveTripItemButton'
import ViewMoreOffersCta from 'tripPlanner/components/Buttons/ViewMoreOffersCta'
import RestoreCartButtons from 'tripPlanner/components/ItemCard/Common/RestoreCartButtons'
import { VIEW_OFFER_COPY } from 'tripPlanner/config'
import TripContext from 'tripPlanner/contexts/TripContext'
import { TripItem } from 'tripPlanner/types/tripItem'
import { isLeBookmark } from 'tripPlanner/utils'
import { itemSectionId } from 'tripPlanner/utils/itemSection'

interface Props {
  item: TripItem
  isOfferAvailable: boolean
  offerId?: string
  checkIn?: Moment
  checkOut?: Moment
  lat?: number
  lng?: number
  variant: ItemCardVariant
}

export function PlannedItemCtaContent(props: Props) {
  const { isOfferAvailable, offerId, checkIn, checkOut, item, lat, lng } = props

  const viewAsTemplate = useContext(TripContext)?.viewAsTemplate
  const isPublicTrip = useContext(TripContext)?.isPublicTrip

  if (!isOfferAvailable) {
    if (item.sourceType === 'LE_Experience' && item.place.type === 'GEO') {
      const hasPlannedInfo = !!item.startDate
      return (
        <Group
          direction="horizontal"
          gap={8}
          tabletHorizontalAlign="space-between"
          horizontalAlign="stretch"
        >
          {hasPlannedInfo && (
            <TextButton kind="tertiary" nonInteractable>
              Change details
            </TextButton>
          )}
          {lat && lng && (
            <ViewNearbyExperiencesCta
              lat={lat}
              lng={lng}
              tripId={item.tripId}
            />
          )}
        </Group>
      )
    } else if (
      item.sourceType === 'LE_Hotel' ||
      item.sourceType === 'LE_Hotel_Bedbank' ||
      item.sourceType === 'LE_Accommodation_Rental'
    ) {
      const hasPlannedInfo = !!checkIn || !!checkOut

      return (
        <Group
          direction="horizontal"
          gap={8}
          tabletHorizontalAlign="space-between"
          horizontalAlign="stretch"
        >
          {hasPlannedInfo && (
            <TextButton kind="tertiary" nonInteractable>
              Change details
            </TextButton>
          )}
          <ViewMoreOffersCta
            offerId={offerId}
            checkIn={checkIn}
            checkOut={checkOut}
            sectionId={itemSectionId(item.id)}
            tripId={item.tripId}
          />
        </Group>
      )
    } else if (item.sourceType === 'LE_Tour') {
      const hasPlannedInfo = !!checkIn || !!checkOut

      return (
        <Group
          direction="horizontal"
          gap={8}
          tabletHorizontalAlign="space-between"
          horizontalAlign="stretch"
        >
          {hasPlannedInfo && (
            <TextButton kind="tertiary" nonInteractable>
              Change details
            </TextButton>
          )}
          {lat && lng && <ViewNearbyToursCta item={item} lat={lat} lng={lng} />}
        </Group>
      )
    }
  } else if (isLeBookmark(item)) {
    if (viewAsTemplate || isPublicTrip) {
      return (
        <Group direction="horizontal" gap={12}>
          <SaveTripItemButton item={item} />
          <TextButton kind="primary" nonInteractable>
            {VIEW_OFFER_COPY}
          </TextButton>
        </Group>
      )
    } else {
      return <RestoreCartButtons item={item} variant={props.variant} />
    }
  }

  return null
}
